/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ContractDocumentsControllerFindAllQueryResponse, ContractDocumentsControllerFindAllQueryParams, ContractDocumentsControllerFindAll401, ContractDocumentsControllerFindAll403 } from "../../models/contractDocumentsController/ContractDocumentsControllerFindAll";

function getContractDocumentsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/contract-documents` as const }  
  return res
}

/**
 * @summary List a project's contract documents (filter[scopeId] required)
 * {@link /api/v1/contract-documents}
 */
export async function contractDocumentsControllerFindAll(params?: ContractDocumentsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ContractDocumentsControllerFindAllQueryResponse, ResponseErrorConfig<ContractDocumentsControllerFindAll401 | ContractDocumentsControllerFindAll403>, unknown>({ method : "GET", url : getContractDocumentsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}